import React from 'react';
import {
    ReferenceDot,
    Text,
    AreaChart,
    Area,
    XAxis,
    YAxis,
    ResponsiveContainer
} from 'recharts';
import publicDebts2009 from "../data/public2009.json";
import publicDebts2016 from "../data/public2016.json";
import privateDebts2009 from "../data/private2009";
import privateDebts2016 from "../data/private2016";
import forProfit2009 from "../data/forProfit2009";
import forProfit2016 from "../data/forProfit2016";
import createGaussian from "../data/utils";


const blue = "#0164b3";
const magenta = "#e3007d";
const navy = "#1b3d67";

const tickFormatter = (value) => "$" + commas(value);
const commas = (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

class Distribution extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            publicGaussian2009: createGaussian(publicDebts2009),
            publicGaussian2016: createGaussian(publicDebts2016),
            privateGaussian2009: createGaussian(privateDebts2009),
            privateGaussian2016: createGaussian(privateDebts2016),
            forProfitGaussian2009: createGaussian(forProfit2009),
            forProfitGaussian2016: createGaussian(forProfit2016)
        }
    }

    render() {
        return (
            <div >
                <div style={{ width: '90%', height: 125 }}>
                    <Text  style={{"color": blue, fontWeight :"bold"}}>{"Public Institutions"}</Text>
                    <ResponsiveContainer>
                        <AreaChart
                            syncId={"id"}
                            data={this.state.publicGaussian2009}
                            margin={{
                                top: 5, right: 30, left: 20, bottom: 5,
                            }}
                        >
                            <XAxis hide tickFormatter={tickFormatter} dataKey={"x"} type="number"/>
                            <YAxis dataKey={"y"} hide/>
                            <Area type="monotone" dataKey="y" fill={blue} stroke={blue} opacity={.75} />
                            <ReferenceDot x={60000} y={.00002} shape={<NoRender />} label={{fontWeight: "bold", value: "2009", fill:blue, angle: 90}}/>
                        </AreaChart>
                    </ResponsiveContainer>
                    <ResponsiveContainer height={170}>
                        <AreaChart
                            syncId={"id"}
                            data={this.state.publicGaussian2016}
                            margin={{
                                top: 0, right: 30, left: 20, bottom: 50,
                            }}
                        >
                            <XAxis hide tickFormatter={tickFormatter} dataKey={"x"} type="number"/>
                            <YAxis dataKey={"y"} hide/>
                            <Area type="monotone" dataKey="y" fill={blue} stroke={blue} opacity={.75} />
                            <ReferenceDot x={60000} y={.00002} shape={<NoRender />} label={{fontWeight: "bold", value: "2016", fill:blue, angle: 90}}/>
                        </AreaChart>
                    </ResponsiveContainer>
                    <Text style={{"color": magenta, fontWeight: "bold"}}>{"Private Non-Profit Institutions"}</Text>
                    <ResponsiveContainer>
                        <AreaChart
                            syncId={"id"}
                            data={this.state.privateGaussian2009}
                            margin={{
                                top: 0, right: 30, left: 20, bottom: 5,
                            }}

                        >
                            <XAxis hide tickFormatter={tickFormatter} dataKey={"x"} type="number"/>
                            <YAxis dataKey={"y"} hide/>
                            <Area type="monotone" dataKey="y" fill={magenta} stroke={magenta} opacity={.75} />
                            <ReferenceDot x={60000} y={.00002} shape={<NoRender />} label={{fontWeight: "bold", value: "2009", fill:magenta, angle: 90}}/>
                        </AreaChart>
                    </ResponsiveContainer>
                    <ResponsiveContainer height={170}>
                        <AreaChart
                            syncId={"id"}
                            data={this.state.privateGaussian2016}
                            margin={{
                                top: 5, right: 30, left: 20, bottom: 50,
                            }}
                        >
                            <XAxis hide tickFormatter={tickFormatter} dataKey={"x"} type="number"/>
                            <YAxis dataKey={"y"} hide/>
                            <Area type="monotone" dataKey="y" fill={magenta} stroke={magenta} opacity={.75} />
                            <ReferenceDot x={60000} y={.00002} shape={<NoRender />} label={{fontWeight: "bold", value: "2016", fill:magenta, angle: 90}}/>
                        </AreaChart>
                    </ResponsiveContainer>
                    <Text style={{"color": navy, fontWeight: "bold"}}>{"Private For-Profit Institutions"}</Text>
                    <ResponsiveContainer>
                        <AreaChart
                            syncId={"id"}
                            data={this.state.forProfitGaussian2009}
                            margin={{
                                top: 0, right: 30, left: 20, bottom: 5,
                            }}
                        >
                            <XAxis hide tickFormatter={tickFormatter} dataKey={"x"} type="number"/>
                            <YAxis dataKey={"y"} hide/>
                            <Area type="monotone" dataKey="y" fill={navy} stroke={navy} opacity={.75} />
                            <ReferenceDot x={60000} y={.00002} shape={<NoRender />} label={{fontWeight: "bold", value: "2009", fill:navy, angle: 90}}/>
                        </AreaChart>
                    </ResponsiveContainer>
                    <ResponsiveContainer height={155}>
                        <AreaChart
                            syncId={"id"}
                            data={this.state.forProfitGaussian2016}
                            margin={{
                                top: 0, right: 30, left: 20, bottom: 5,
                            }}
                        >
                            <XAxis tickFormatter={tickFormatter} dataKey={"x"} type="number"/>
                            <YAxis dataKey={"y"} hide/>
                            <Area type="monotone" dataKey="y" fill={navy} stroke={navy} opacity={.75} />
                            <ReferenceDot x={60000} y={.00003} shape={<NoRender />} label={{fontWeight: "bold", value: "2016", fill:navy, angle: 90}}/>
                        </AreaChart>
                    </ResponsiveContainer>
                </div>
            </div>

        )
    }
}


const NoRender = () => {
    return null;
}

export default Distribution;